// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"w3-z","displaySixCardTiles":"x3-z"};